import {
    memo,
} from 'react'
import useLabel from 'app/hooks/useLabel'
import SkyNetDataGrid, {
    SelectionType,
} from 'app/shared-components/SkyNetDataGrid'
import applyDataToDataSource from 'app/shared-components/SkyBaseDataGrid/utils/applyDataToDataSource'
import {
    finalSelectionLaneFeesColumns,
} from './finalSelection.columns'

export default memo(({
    rows,
    defaultSelected,
    handleSelect,
    classes,
}: Readonly<{
    rows: unknown[]
    defaultSelected: string[]
    handleSelect: (ids: Set<string>) => void
    classes: Record<string, string>
}>) => {
    const getLabel = useLabel()

    return (
        <SkyNetDataGrid
            persistentKey="DEMO-create-quote-lane-fees"
            customDataSource={applyDataToDataSource(rows)}
            columns={finalSelectionLaneFeesColumns}
            toolbarProps={{
                title: getLabel('LANE_SLASH_LANE_FEES'),
                toolbarControls: [],
                showClearSort: false,
            }}
            selectionType={SelectionType.Checkbox}
            getRowId={(row) => {
                return row.tempId
            }}
            selectedRows={defaultSelected}
            onSelectedRow={handleSelect}
            classNames={{
                tableWrapper: classes.tableWrapper,
            }}
        />
    )
})
